<template>
  <svg
    v-if="icon === ICON_LIST.ARROW_DOWN_LEFT"
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
  >
    <path
      d="M11 46.4796L56.904 0.575623L64.4453 8.11696L18.5413 54.021H59V64.6876H0.333332V6.02096H11V46.4743V46.4796Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.ARROW_DOWN_RIGHT"
    width="66"
    height="66"
    viewBox="0 0 66 66"
    fill="none"
  >
    <path
      d="M46.8136 54.3543L0.904236 8.45027L8.44557 0.908936L54.3496 46.8076V6.35427H65.0162V65.0209H6.34957V54.3543H46.8136Z"
      fill="#1C1C1E"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.ARROW_BOTTOM_RIGHT"
    width="66"
    height="66"
    viewBox="0 0 66 66"
    fill="none"
  >
    <path
      d="M46.8136 54.3543L0.904236 8.45027L8.44557 0.908936L54.3496 46.8076V6.35427H65.0162V65.0209H6.34957V54.3543H46.8136Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.ARROW_DOWN"
    width="84"
    height="86"
    viewBox="0 0 84 86"
    fill="none"
  >
    <path
      d="M47.3335 65.2507L75.9415 36.6427L83.4829 44.184L42.0002 85.6667L0.517532 44.184L8.05887 36.6427L36.6669 65.2507V0.333344H47.3335V65.2507Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.ARROW_LEFT"
    width="86"
    height="84"
    viewBox="0 0 86 84"
    fill="none"
  >
    <path
      d="M20.7493 36.6674H85.6667V47.3341H20.7493L49.3573 75.9421L41.816 83.4834L0.333334 42.0007L41.816 0.518066L49.3573 8.0594L20.7493 36.6674Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.ARROW_RIGHT"
    width="86"
    height="84"
    viewBox="0 0 86 84"
    fill="none"
  >
    <path
      d="M65.2507 36.6674L36.6427 8.0594L44.184 0.518066L85.6667 42.0007L44.184 83.4834L36.6427 75.9421L65.2507 47.3341H0.333344V36.6674H65.2507Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.ARROW_UP_LEFT"
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
  >
    <path
      d="M18.208 10.6667L64.112 56.5707L56.5707 64.112L10.6667 18.208V58.6667H0V0H58.6667V10.6667H18.208Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.ARROW_UP_RIGHT"
    width="66"
    height="65"
    viewBox="0 0 66 65"
    fill="none"
  >
    <path
      d="M54.3548 18.208L8.45082 64.112L0.909485 56.5707L46.8082 10.6667H6.35482V0H65.0215V58.6667H54.3548V18.208Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.ARROW_UP"
    width="84"
    height="86"
    viewBox="0 0 84 86"
    fill="none"
  >
    <path
      d="M47.3335 20.7493V85.6666H36.6669V20.7493L8.05887 49.3573L0.517532 41.816L42.0002 0.333313L83.4829 41.816L75.9415 49.3573L47.3335 20.7493Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.FLAG"
    width="106"
    height="102"
    viewBox="0 0 106 102"
    fill="none"
  >
    <path
      d="M11.3334 74.6667V101.333H0.666687V3.75657e-06H102.736C103.203 -0.000780732 103.663 0.121317 104.068 0.354057C104.474 0.586798 104.811 0.922004 105.046 1.32608C105.281 1.73015 105.405 2.18889 105.407 2.65633C105.409 3.12376 105.288 3.58345 105.056 3.98934L86 37.3333L105.056 70.6773C105.288 71.0832 105.409 71.5429 105.407 72.0104C105.405 72.4778 105.281 72.9365 105.046 73.3406C104.811 73.7447 104.474 74.0799 104.068 74.3126C103.663 74.5454 103.203 74.6675 102.736 74.6667H11.3334ZM11.3334 10.6667V64H88.9547L73.712 37.3333L88.9547 10.6667H11.3334Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.ELEVATOR_DOWN"
    width="108"
    height="96"
    viewBox="0 0 108 96"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.666687 5.33334C0.666687 2.38782 3.0545 0 6.00002 0H59.3333C62.2789 0 64.6667 2.38781 64.6667 5.33333V90.6667C64.6667 93.6122 62.2789 96 59.3333 96H6.00002C3.0545 96 0.666687 93.6122 0.666687 90.6667V5.33334ZM40.6667 18.6667C40.6667 23.0849 37.085 26.6667 32.6667 26.6667C28.2484 26.6667 24.6667 23.0849 24.6667 18.6667C24.6667 14.2484 28.2484 10.6667 32.6667 10.6667C37.085 10.6667 40.6667 14.2484 40.6667 18.6667ZM22 42.6667C22 36.7756 26.7756 32 32.6667 32C38.5577 32 43.3334 36.7756 43.3334 42.6667V64H38V85.3333H27.3334V64H22V42.6667ZM88.6667 77.3333L70 58.6667L83.3334 58.6667V21.3333H94V58.6667H107.333L88.6667 77.3333Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.ELEVATOR_UP"
    width="108"
    height="96"
    viewBox="0 0 108 96"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.666687 5.33334C0.666687 2.38782 3.0545 0 6.00002 0H59.3333C62.2789 0 64.6667 2.38781 64.6667 5.33333V90.6667C64.6667 93.6122 62.2789 96 59.3333 96H6.00002C3.0545 96 0.666687 93.6122 0.666687 90.6667V5.33334ZM40.6667 18.6667C40.6667 23.0849 37.085 26.6667 32.6667 26.6667C28.2484 26.6667 24.6667 23.0849 24.6667 18.6667C24.6667 14.2484 28.2484 10.6667 32.6667 10.6667C37.085 10.6667 40.6667 14.2484 40.6667 18.6667ZM22 42.6667C22 36.7756 26.7756 32 32.6667 32C38.5577 32 43.3334 36.7756 43.3334 42.6667V64H38V85.3333H27.3334V64H22V42.6667ZM88.6667 18.6667L70 37.3333H83.3334V74.6667H94V37.3333H107.333L88.6667 18.6667Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.OPERATOR"
    width="86"
    height="108"
    viewBox="0 0 86 108"
    fill="none"
  >
    <path
      d="M43 70C64.76 70 82.712 86.288 85.336 107.333H0.664047C3.28805 86.288 21.24 70 43 70ZM33.3307 82.16C25.6827 84.5814 19.2454 89.8027 15.2667 96.6667H43L33.3307 82.16ZM52.6747 82.16L43 96.6667H70.728C66.7547 89.8027 60.3174 84.5814 52.6747 82.16ZM75 0.666687V32.6667C75 50.3414 60.6747 64.6667 43 64.6667C25.3254 64.6667 11 50.3414 11 32.6667V0.666687H75ZM21.6667 32.6667C21.6667 44.4534 31.2134 54 43 54C54.7867 54 64.3334 44.4534 64.3334 32.6667H21.6667ZM64.3334 11.3334H21.6667V22H64.3334V11.3334Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.STAIRS_DOWN_LEFT"
    width="108"
    height="101"
    viewBox="0 0 108 101"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M75.3334 25.6665H107.333V36.3332H86V57.6665H64.6667V78.9998H43.3334V100.333H0.666687V89.6665H32.6667V68.3332H54V46.9998H75.3334V25.6665Z"
      :fill="color"
    />
    <path
      d="M57.7707 8.10384L24.4374 41.4372L35.3334 52.3332L6.00002 52.3332L6.00003 22.9998L16.896 33.8958L50.2294 0.5625L57.7707 8.10384Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.STAIRS_DOWN_RIGHT"
    width="108"
    height="101"
    viewBox="0 0 108 101"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.6666 25.6665H0.666641V36.3332H22V57.6665H43.3333V78.9998H64.6666V100.333H107.333V89.6665H75.3333V68.3332H54V46.9998H32.6666V25.6665Z"
      :fill="color"
    />
    <path
      d="M50.2293 8.10384L83.5626 41.4372L72.6666 52.3332L102 52.3332L102 22.9998L91.104 33.8958L57.7706 0.5625L50.2293 8.10384Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.STAIRS_UP_LEFT"
    width="108"
    height="102"
    viewBox="0 0 108 102"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.6666 26.6667H0.666641V37.3333H22V58.6667H43.3333V80H64.6666V101.333H107.333V90.6667H75.3333V69.3333H54V48H32.6666V26.6667Z"
      :fill="color"
    />
    <path
      d="M105.771 44.2293L72.4375 10.896L83.3335 0L54.0001 3.84659e-06L54.0001 29.3333L64.8961 18.4373L98.2295 51.7707L105.771 44.2293Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else-if="icon === ICON_LIST.STAIRS_UP_RIGHT"
    width="108"
    height="102"
    viewBox="0 0 108 102"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M75.3334 26.6667H107.333V37.3333H86V58.6667H64.6667V80H43.3334V101.333H0.666687V90.6667H32.6667V69.3333H54V48H75.3334V26.6667Z"
      :fill="color"
    />
    <path
      d="M2.22919 44.2293L35.5625 10.896L24.6665 0L53.9999 3.84659e-06L53.9999 29.3333L43.1039 18.4373L9.77052 51.7707L2.22919 44.2293Z"
      :fill="color"
    />
  </svg>
</template>

<script>
import ICON_LIST from '../helpers/TicketIcons';

export default {
  name: 'TicketIcon',
  props: {
    color: {
      type: String,
      default: '#1c1c1e'
    },
    icon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ICON_LIST
    }
  }
}
</script>